module.exports = __webpack_public_path__ + "static/media/Coverart.8c600773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/Coverart.jpg
// module id = 352
// module chunks = 0